const FlipScaleVariablesList = [
    "R_A_ForceSpray",
    "R_A_SprayCloud",
    "R_St_GreasyMarksRat_5pt",
    "R_St_GreasyMarksRat_100pt",
    "R_A_TooMuchSprayCloud",
    "R_A_GreasyApp",
    "R_A_StickyApp",
    "R_A_WetApp",
    "R_S_FeelGreasy",
    "R_S_FeelWet",
    "R_S_FeelSticky",
    "R_St_WhiteMarksSkinRat_5pt",
    "R_St_WhiteMarksSkinRat_100pt",
    "R_St_WhiteMarksClothesRat_5pt",
    "R_St_WhiteMarksClothesRat_100pt",
    "R_St_ResidueSkin",
    "R_A_Crumble",
    "R_A_Messy",
];

export default FlipScaleVariablesList;
